"use strict";

require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.date.to-string");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
var Languages_1 = require("Core/Languages");
var decimal_js_1 = require("decimal.js");
var CartCalc = function () {
  function CartCalc() {}
  CartCalc.codDeliveryOperation = function () {
    var $delivery = $("#delivery");
    var $col = $delivery.find(".delivery_method_radio:checked");
    var $payment = $("#payment");
    var $deliveryId = $col.val();
    var $deliveryIsCod = $col.data("is-cod");
    var $deliveryPrice = $col.data("is-price");
    var $deliveryCodLimit = $col.data("cod-limit");
    var $deliveryCodPrice = $col.data("cod-price");
    var $paymentCheckedRadio = $payment.find(".payment_method_radio:checked");
    var $paymentCheckedRadioIdElement = $paymentCheckedRadio.attr('id');
    var $paymentCheckedRadioDivIdElement = CartCalc.editElement($paymentCheckedRadioIdElement);
    var $selectedPaymentId = $col.val();
    var $paymentMethodMessage = $payment.find("#payment_method-message");
    var $parcelLockerSelect = $('#selected-parcel-locker');
    var $wantAnotherDeliveryCheckbox = $('#want_another_delivery_address');
    var $anotherDeliveryData = $('#another-delivery-address-data');
    var $cart = $("#cart-content");
    var $currency = $cart.data("cart-currency");
    var $currencyCalc = $cart.data("cart-currency-calc");
    var $payuOption = $("#payment_method_1");
    var $transferOption = $("#payment_method_2");
    var $codOption = $("#payment_method_4");
    var $cashOption = $("#payment_method_6");
    var $przelewy24Option = $("#payment_method_8");
    var $radioCashOption = $("#cart_payment_method_6");
    var $codMethod = $("#delivery_method_12");
    var $courierInpostMethod = $("#delivery_method_11");
    var $courierDpdMethod = $("#delivery_method_10");
    var $codId = 12;
    var courierInpostId = 21;
    var courierDpdId = 10;
    var parcelLocker = 3;
    var $isCod = false;
    var $isCash = false;
    var $isCourier = false;
    var $isPersonal = false;
    if ($deliveryIsCod == "f") {
      $isCod = true;
    }
    if ($deliveryId == courierInpostId || $deliveryId == courierDpdId) {
      $isCash = true;
    }
    if ($cashOption.find("input").prop("checked") == true) {
      $isCourier = true;
      $courierInpostMethod.prop("checked", false);
      $courierDpdMethod.prop("checked", false);
    }
    if ($codOption.find("input").prop("checked") == true) {
      $isPersonal = true;
      $codMethod.prop("checked", false);
    }
    if ($deliveryId == parcelLocker) {
      $parcelLockerSelect.show({
        duration: 600
      });
      if ($wantAnotherDeliveryCheckbox.prop('checked') == true) {
        $anotherDeliveryData.hide();
        $wantAnotherDeliveryCheckbox.prop('checked', false);
      }
      $wantAnotherDeliveryCheckbox.prop('disabled', true);
    } else {
      $parcelLockerSelect.hide({
        duration: 600
      });
      $wantAnotherDeliveryCheckbox.prop('disabled', false);
    }
    $courierInpostMethod.toggleClass("disabled", $isCourier);
    $courierDpdMethod.toggleClass("disabled", $isCourier);
    $codMethod.toggleClass("disabled", $isPersonal);
    $codOption.toggle(!$isCod);
    $cashOption.toggle($isCash);
    if ($isCod == true) {
      $codOption.find("input").prop("checked", false);
    }
    var $codMethodAvailable = CartCalc.checkCodMethodIsAvailable($isCod, $deliveryCodLimit, $deliveryCodPrice, $deliveryPrice);
    if ($codMethodAvailable) {
      $radioCashOption.prop("disabled", true).prop("checked", false);
      $cashOption.addClass("locked");
      $paymentMethodMessage.text('');
    } else {
      var textMessage = 'Uwaga: pobranie nie jest możliwe przy zamówieniu przekraczającym ' + this.showPrice($deliveryCodLimit, 'zł');
      $paymentMethodMessage.text(textMessage);
    }
    if ($col.length > 0) {
      $paymentMethodMessage.removeClass('d-none');
    }
  };
  CartCalc.editElement = function (element) {
    if (element) {
      return element.replace("cart_", "");
    } else {
      return null;
    }
  };
  CartCalc.checkCodMethodIsAvailable = function ($isCod, $deliveryCodLimit, $deliveryCodPrice, $deliveryPrice) {
    var codLimit = new decimal_js_1.Decimal($deliveryCodLimit || 0);
    var codPrice = new decimal_js_1.Decimal($deliveryCodPrice || 0);
    var price = new decimal_js_1.Decimal($deliveryPrice || 0);
    var totalCost = new decimal_js_1.Decimal(this.$totalCost || 0);
    if ($isCod && codLimit.greaterThan(0)) {
      totalCost = totalCost.plus(codPrice).plus(price);
      return !totalCost.greaterThan(codLimit);
    }
    return true;
  };
  CartCalc.showPrice = function (price, currency) {
    price = parseFloat(price).toFixed(2);
    var parts = price.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    var formattedPrice = parts.join(",");
    return formattedPrice + " " + currency;
  };
  CartCalc.convertedPrice = function ($price, $currency, $currencyCalc, $ceil) {
    if ($ceil === void 0) {
      $ceil = false;
    }
    var $endPrice = $price / $currencyCalc;
    if ($ceil) {
      $endPrice = Math.ceil($endPrice);
    }
    return this.showPrice($endPrice, $currency);
  };
  CartCalc.calcDelivery = function () {
    var $formUrl = $("#cart-content form").attr('action');
    var $delivery = $("input[name='cart[delivery_method]']:checked").val();
    var $payment = $("input[name='cart[payment_method]']:checked").val();
    var urlLang = Languages_1.getCurrentLanguageUrl;
    var $url = urlLang + "/a_cart/calc";
    this.codDeliveryOperation();
    $.ajax({
      type: "POST",
      url: $url,
      data: {
        delivery_method: $delivery,
        payment_method: $payment
      },
      success: function success(res) {
        if (res && res.result) {
          $("#col-total-info").html(res.msg.html);
          if (res.msg.isNotStepTwo == false) {
            $('.weightAndHeightTable').hide();
          }
          $('#summary-delivery-price').text(CartCalc.preparePriceToDisplay(res.value.total));
          var $deliveryValue = $("#summary-delivery-price").html();
          if ($deliveryValue != null) {
            var value = $deliveryValue.split(" ")[0];
            $("#agree_delivery").toggle(parseInt($deliveryValue) > 0);
          }
        } else {
          $("#col-total-info").html("<p>Error</p>");
        }
      }
    });
  };
  CartCalc.addPaymentDeliveryCost = function () {
    var $delivery = $("input[name='cart[delivery_method]']:checked").val();
    var urlLang = Languages_1.getCurrentLanguageUrl;
    var $url = urlLang + "/a_cart/codPrice";
    $.ajax({
      type: "POST",
      url: $url,
      data: {
        delivery_method: $delivery
      },
      success: function success(res) {
        if (res && res.result) {
          $('#deliveryCodPrice').html("+" + res.msg.codDeliveryPrice);
        } else {
          $("#col-total-info").html("<p>Error</p>");
        }
      }
    });
  };
  CartCalc.preparePriceToDisplay = function (price) {
    return price.replace('&nbsp;', ' ');
  };
  CartCalc.checkPaymentAndDelivery = function () {
    event.preventDefault();
    var $col = $("#delivery").find(".delivery_method_radio:checked");
    var $deliveryPrice = $col.data("is-price");
    var $deliveryCodLimit = $col.data("cod-limit");
    var $deliveryCodPrice = $col.data("cod-price");
    var $codOption = $("#payment_method_4");
    var $isCod = $codOption.prop("checked");
    return CartCalc.checkCodMethodIsAvailable($isCod, $deliveryCodLimit, $deliveryCodPrice, $deliveryPrice);
  };
  CartCalc.$totalCost = $("#summary-delivery-price").data("summary-delivery-price");
  return CartCalc;
}();
exports.CartCalc = CartCalc;